import { Dispatch, SetStateAction } from 'react';
import FullAddressForm from '../../../../../components/FullAddressForm';
import { GetErrorMessageByFieldNameType, RemoveErrorType, SetErrorType } from '../../../../../hooks/useErrors';
import { Container as StyledContainer } from '../styles';

interface AddressDataCardInterface {
  lat: number | string;
  lng: number | string;
  cep: string;
  streetName: string;
  number: number | string;
  district: string;
  city: string;
  uf: string;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  setError: SetErrorType;
  removeError: RemoveErrorType;
  getErrorMessageByFieldName: GetErrorMessageByFieldNameType;
  handleLatChange: (value: string) => void
  handleLngChange: (value: string) => void
  handleCepChange: (value: string) => void
  handleStreetNameChange: (value: string) => void
  handleNumberChange: (value: string | number) => void
  handleDistrictChange: (value: string) => void
  handleCityChange: (value: string) => void
  handleUfChange: (value: string) => void
}

export default function AddressDataCard({
  lat,
  lng,
  cep,
  streetName,
  number,
  district,
  city,
  uf,
  handleLatChange,
  handleLngChange,
  handleCepChange,
  handleStreetNameChange,
  handleNumberChange,
  handleDistrictChange,
  handleCityChange,
  handleUfChange,
  setError,
  setIsLoading,
  removeError,
  getErrorMessageByFieldName,
}: AddressDataCardInterface) {
  return (
    <StyledContainer>
      <div className="card-title">
        Endereço
      </div>
      <FullAddressForm
        lat={lat}
        lng={lng}
        cep={cep}
        streetName={streetName}
        number={number}
        district={district}
        city={city}
        uf={uf}
        onLatChange={handleLatChange}
        onLngChange={handleLngChange}
        onCepChange={handleCepChange}
        onStreetNameChange={handleStreetNameChange}
        onNumberChange={handleNumberChange}
        onDistrictChange={handleDistrictChange}
        onCityChange={handleCityChange}
        onUfChange={handleUfChange}
        setError={setError}
        setIsLoading={setIsLoading}
        removeError={removeError}
        getErrorMessageByFieldName={getErrorMessageByFieldName}
      />
    </StyledContainer>
  );
}
